import { useCallback } from 'react';
import { BlockerFunction } from 'react-router-dom';

export const useSummaryStockLevelsBlocker = (registerUnsavedChanges: boolean) => {
  const blocker: BlockerFunction = useCallback(
    ({ nextLocation }) => {
      if (registerUnsavedChanges && !nextLocation.pathname.includes('summaryStockLevels')) {
        return true;
      }
      return false;
    },
    [registerUnsavedChanges]
  );

  return blocker;
};
